export const GATES = {
  INBOX_NAVIGATION: 'CustomerPortal::InboxNavigation::FE'
};